import React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import { graphql, StaticQuery } from "gatsby";

const Seo = ({ seo = {} }) => {
  const getMetaTags = (combinedSeo) => {
    const tags = [];

    if (combinedSeo.noindex) {
      tags.push({
        property: "robots",
        content: "noindex",
      });
    }

    if (combinedSeo.title) {
      tags.push(
        {
          property: "og:title",
          content: combinedSeo.title,
        },
        {
          name: "twitter:title",
          content: combinedSeo.title,
        }
      );
    }
    if (combinedSeo.description) {
      tags.push(
        {
          name: "description",
          content: combinedSeo.description,
        },
        {
          property: "og:description",
          content: combinedSeo.description,
        },
        {
          name: "twitter:description",
          content: combinedSeo.description,
        }
      );
    }
    if (combinedSeo.image) {
      let imageUrl =
        typeof combinedSeo.image === "string"
          ? combinedSeo.image
          : combinedSeo.image.images.fallback.src;

      imageUrl = "https://theamx.com" + imageUrl;

      tags.push(
        {
          name: "image",
          content: imageUrl,
        },
        {
          property: "og:image",
          content: imageUrl,
        },
        {
          name: "twitter:image",
          content: imageUrl,
        }
      );
    }
    if (combinedSeo.article) {
      tags.push({
        property: "og:type",
        content: "article",
      });
    }
    tags.push({ name: "twitter:card", content: "summary_large_image" });

    return tags;
  };

  return (
    <StaticQuery
      query={graphql`
        query {
          strapiHomepage {
            metaData {
              metadescription
              pageTitle
            }
            hero {
              image {
                localFile {
                  publicURL
                }
              }
            }
          }
          strapiGlobal {
            SiteName
          }
        }
      `}
      render={(data) => {
        const { strapiHomepage, strapiGlobal } = data;

        const { metaData, hero } = strapiHomepage;
        const { metadescription, pageTitle } = metaData;
        const siteName = strapiGlobal.SiteName;

        const defaultSeo = {
          description: metadescription,
          title: pageTitle,
          image: hero ? hero.image.localFile.publicURL : undefined,
          article: false,
        };

        // Merge default and page-specific SEO values
        const fullSeo = { ...defaultSeo, ...seo };

        const metaTags = getMetaTags(fullSeo);

        return (
          <Helmet
            htmlAttributes={{
              lang: "en",
            }}
            title={fullSeo.title}
            titleTemplate={`%s | ${siteName}`}
            meta={metaTags}
          >
            {/* Google Tag Manager */}
            <script
              data-position={1}
            >{`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-5L4JJPQ');`}</script>
            {/* End Google Tag Manager */}
          </Helmet>
        );
      }}
    />
  );
};

export default Seo;

Seo.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
  article: PropTypes.bool,
};

Seo.defaultProps = {
  title: null,
  description: null,
  image: null,
  article: false,
};
